export const JOB_TYPE_OPTIONS = [
  {
    value: 'both',
    label: 'Both Fixed or Hourly',
  },
  {
    value: 'hourly',
    label: 'Hourly Rate',
  },
  {
    value: 'fixed',
    label: 'Fixed Budget',
  },
];

export const TOKEN_KEYS = {
  access: 'US_ACCESS_TOKEN',
  accessExpire: 'US_ACCESS_EXPIRE',
  refresh: 'US_REFRESH_TOKEN',
  refreshExpire: 'US_REFRESH_EXPIRE',
};

export const ROUTES = {
  home: '/',
  dashboard: '/dashboard',
  login: '/auth/sign-in',
  register: '/auth/sign-up',
  filters: '/filters',
  filterDetail: '/filters/:id',
  slack: '/slack',
  slackDetail: '/slack/:id',
  discord: '/discord',
  discordDetail: '/discord/:id',
};

export const QUERY_KEYS = {
  upworkCrawlerCategories: 'upworkCrawlerCategories',
  upworkCrawlerExperienceLevels: 'upworkCrawlerExperienceLevels',
  upworkCrawlerLocations: 'upworkCrawlerLocations',
  googleSheetsSpreadsheet: 'googleSheetsSpreadsheet',
  upworkCrawlerJobFilters: 'upworkCrawlerJobFilters',
  upworkCrawlerJobFilterDetail: 'upworkCrawlerJobFilterDetail',
  slackWebhooks: 'slackWebhooks',
  slackWebhookDetail: 'slackWebhookDetail',
  discordWebhooks: 'discordWebhooks',
  discordWebhookDetail: 'discordWebhookDetail',
  webhookUsage: 'webhookUsage',
};

export const API_PREFIX = 'api';

export const API_ENDPOINTS = {
  slack: 'slack/webhook',
  discord: 'discord/webhook',
  categories: 'upwork-crawler/categories',
  experienceLevels: 'upwork-crawler/experience-levels',
  locations: 'upwork-crawler/locations',
  spreadsheet: 'google-sheets/spreadsheet',
  jobFilters: 'upwork-crawler/job-filters',
  webhookUsage: 'upwork-crawler/webhook-in-use',
  me: 'users/me',
  login: 'auth/login',
  register: 'auth/register',
  refreshToken: 'auth/refresh-token',
};
